import { push } from 'redux-first-history';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import { history } from '../../../redux/store';
import actions from './actions';
import { logger } from '../../../helpers/logger';
import Api from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import notifications from '../../../redux/notifications/actions';
import { keyByProperty } from '../../../helpers/core';
import { t } from '../../../i18n';

const api = new Api('organizations/enterprise');
const organizationApi = new Api('organizations/enterprise/:id');
const formDataApi = new Api('organizations/enterprise/form_data');

function* loadFormDataRequest() {
  try {
    const result = yield call(sendRequest, formDataApi.load, {}, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      yield put(actions.loadFormDataSuccess({ formInfo: result.data.success.data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadDataRequest({ payload: { id, isOrgEditing } }) {
  try {
    yield put(actions.loadFormDataRequest());

    if (id === 'create') {
      return yield put(actions.create());
    }

    const result = yield call(sendRequest, organizationApi.load, { id }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data?.organization) {
      const { organization } = result.data.success.data;

      yield put(actions.loadDataSuccess({ data: organization }));

      if (isOrgEditing) {
        yield put(actions.edit({ data: organization }));
      }
    } else {
      actions.loadDataError();
    }
  } catch (error) {
    logger.error(error);
  }
}

function* addOrganizationRequest({ payload }) {
  try {
    const propsArray = Object.values(payload.editForm);
    const organization = keyByProperty(propsArray, 'name', prop => prop.value);

    const { countryCode: _countryCode, ...organizationToSend } = organization;

    if (Array.isArray(organizationToSend.countries)) {
      organizationToSend.countries = organizationToSend.countries.map(c => c.id);
    }

    const result = yield call(
      sendRequest,
      api.createItem,
      { data: { organization: organizationToSend } },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.organization) {
      yield put(actions.addOrganizationSuccess());
      yield put(push(`/${history.location.pathname.split('/')[1]}`));
    } else {
      yield put(actions.addOrganizationError(result));

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.check_validation_errors'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateOrganizationRequest({ payload }) {
  try {
    const propsArray = Object.values(payload.editForm);
    const organization = keyByProperty(propsArray, 'name', prop => prop.value);

    const { countryCode: _countryCode, ...organizationToSend } = organization;

    if (Array.isArray(organizationToSend.countries)) {
      organizationToSend.countries = organizationToSend.countries.map(c => c.id);
    }

    const result = yield call(
      sendRequest,
      organizationApi.updateItem,
      { data: { organization: organizationToSend }, id: payload.id },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.organization) {
      yield put(actions.saveOrganizationSuccess());
      yield put(push(`/${history.location.pathname.split('/')[1]}`));
    } else {
      yield put(actions.saveOrganizationError(result));

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.check_validation_errors'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_FORM_DATA_REQUEST, loadFormDataRequest),
    takeEvery(actions.ADD_REQUEST, addOrganizationRequest),
    takeEvery(actions.LOAD_REQUEST, loadDataRequest),
    takeEvery(actions.SAVE_REQUEST, updateOrganizationRequest),
  ]);
}
